import {
  IBaseMigrationSterilisationMachine,
  SterilisationMachineMappingHandler,
} from '../../../mappings/sterilisation-machine';
import {
  CorePracticeSterilisationMachine,
  ICorePracticeSterilisationMachine,
  SterilisationMachineSourceEntity,
} from '../../source/entities/sterilisation-machines';

export class CorePracticeSterilisationMachineMappingHandler extends SterilisationMachineMappingHandler<
  CorePracticeSterilisationMachine,
  SterilisationMachineSourceEntity
> {
  sourceEntity = new SterilisationMachineSourceEntity();

  translateFn = (
    record: ICorePracticeSterilisationMachine
  ): IBaseMigrationSterilisationMachine => ({
    id: record.name,
    name: record.name,
  });
}
